/**
 * Product Variant Media Filter
 * Automatically filters product images based on selected variant options
 */
(function() {
  // Execute after page load
  window.addEventListener('load', function() {
    setTimeout(initVariantFilter, 500); // Delay initialization to ensure all DOM elements are loaded
  });
  
  // Listen for Shopify variant change events
  document.addEventListener('variant:change', function(event) {
    setTimeout(function() {
      updateMediaByVariant(event.detail.variant);
    }, 100);
  });
  
  // Monitor URL changes (handle cases where variants are switched directly via URL parameters)
  let lastUrl = location.href; 
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      setTimeout(function() {
        checkCurrentVariant();
      }, 300);
    }
  }).observe(document, {subtree: true, childList: true});
  
  // Initialize variant filter
  function initVariantFilter() {
    // Find variant selectors
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;
    
    // Add event listeners to all variant selectors
    const radioButtons = variantSelects.querySelectorAll('input[type="radio"]');
    if (radioButtons.length) {
      radioButtons.forEach(radio => {
        radio.addEventListener('change', function() {
          checkCurrentVariant();
        });
      });
    }
    
    const selectDropdowns = variantSelects.querySelectorAll('select');
    if (selectDropdowns.length) {
      selectDropdowns.forEach(select => {
        select.addEventListener('change', function() {
          checkCurrentVariant();
        });
      });
    }
    
    // Initial filter
    checkCurrentVariant();
  }
  
  // Check current variant and update media
  function checkCurrentVariant() {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;
    
    // Get all selected options
    const selectedOptions = {};
    const optionSelectors = variantSelects.querySelectorAll('fieldset, select');
    
    optionSelectors.forEach(selector => {
      let optionName = '';
      let optionValue = '';
      
      if (selector.tagName === 'FIELDSET') {
        const legend = selector.querySelector('legend');
        if (legend) {
          optionName = legend.textContent.trim();
          const checkedInput = selector.querySelector('input:checked');
          if (checkedInput) {
            optionValue = checkedInput.value;
          }
        }
      } else if (selector.tagName === 'SELECT') {
        const label = document.querySelector(`label[for="${selector.id}"]`);
        if (label) {
          optionName = label.textContent.trim();
          optionValue = selector.value;
        }
      }
      
      if (optionName && optionValue) {
        selectedOptions[optionName.toLowerCase()] = optionValue.toLowerCase();
      }
    });
    
    // Update media based on selected options
    filterMediaByOptions(selectedOptions);
  }
  
  // Update media based on variant
  function updateMediaByVariant(variant) {
    if (!variant) return;
    
    // Convert variant options to option map
    const selectedOptions = {};
    if (variant.options && variant.option_names) {
      variant.option_names.forEach((name, index) => {
        selectedOptions[name.toLowerCase()] = variant.options[index].toLowerCase();
      });
    }
    
    // Filter media based on selected options
    filterMediaByOptions(selectedOptions);
  }
  
  // Filter media items based on selected options
  function filterMediaByOptions(selectedOptions) {
    if (!selectedOptions || Object.keys(selectedOptions).length === 0) return;
    
    // Find all product images
    const mediaItems = document.querySelectorAll('.product__media-item');
    if (!mediaItems.length) return;
    
    let firstVisibleItem = null;
    let hasFilteredItems = false;
    
    // Loop through all images, show or hide based on option tags
    mediaItems.forEach(item => {
      let shouldShow = true;
      
      // Check if this media has any option tags
      let hasOptionTags = false;
      
      // Check each option against media data attributes
      for (const [optionName, optionValue] of Object.entries(selectedOptions)) {
        const dataAttr = `data-${optionName.toLowerCase().replace(/\s+/g, '')}`;
        
        if (item.hasAttribute(dataAttr)) {
          hasOptionTags = true;
          const mediaOptionValue = item.getAttribute(dataAttr).toLowerCase();
          
          // If this option doesn't match and it's not the default media, hide it
          if (mediaOptionValue !== optionValue && !item.classList.contains('is-active')) {
            shouldShow = false;
            break;
          }
        }
      }
      
      // If media has no option tags, show it with all variants
      if (!hasOptionTags) {
        shouldShow = true;
      }
      
      // Show or hide the media item
      if (shouldShow) {
        item.style.display = '';
        if (!firstVisibleItem) {
          firstVisibleItem = item;
        }
      } else {
        item.style.display = 'none';
        hasFilteredItems = true;
      }
    });
    
    // If there are visible images, set the first one as active
    if (firstVisibleItem) {
      mediaItems.forEach(item => {
        item.classList.remove('is-active');
      });
      firstVisibleItem.classList.add('is-active');
      
      // Update thumbnail active state
      updateThumbnails(firstVisibleItem);
    }
    
    // Also filter thumbnails
    filterThumbnails(selectedOptions);
  }
  
  // Update thumbnail active state
  function updateThumbnails(activeItem) {
    const thumbnailList = document.querySelector('.thumbnail-list');
    if (!thumbnailList) return;
    
    const activeMediaId = activeItem.getAttribute('data-media-id');
    const thumbnailItems = thumbnailList.querySelectorAll('li');
    
    thumbnailItems.forEach(thumb => {
      const targetId = thumb.getAttribute('data-target');
      const button = thumb.querySelector('button');
      if (button) {
        button.setAttribute('aria-current', targetId === activeMediaId);
      }
    });
  }
  
  // Filter thumbnails based on selected options
  function filterThumbnails(selectedOptions) {
    const thumbnailItems = document.querySelectorAll('.thumbnail-list li');
    if (!thumbnailItems.length) return;
    
    thumbnailItems.forEach(item => {
      let shouldShow = true;
      
      // Check if this thumbnail has any option tags
      let hasOptionTags = false;
      
      // Check each option against thumbnail data attributes
      for (const [optionName, optionValue] of Object.entries(selectedOptions)) {
        const dataAttr = `data-${optionName.toLowerCase().replace(/\s+/g, '')}`;
        
        if (item.hasAttribute(dataAttr)) {
          hasOptionTags = true;
          const thumbOptionValue = item.getAttribute(dataAttr).toLowerCase();
          
          // If this option doesn't match, hide it
          if (thumbOptionValue !== optionValue) {
            shouldShow = false;
            break;
          }
        }
      }
      
      // If thumbnail has no option tags, show it with all variants
      if (!hasOptionTags) {
        shouldShow = true;
      }
      
      // Show or hide the thumbnail
      item.style.display = shouldShow ? '' : 'none';
    });
  }
})(); 